import { useMutation } from '@tanstack/react-query';

import { CabinEventClient, CabinEventReport } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useSaveNewCabinEvent() {
  return useMutation({
    mutationKey: [queryKeys.CabinEvent.SaveNew],
    mutationFn: (report: CabinEventReport) => cabinEventClient.saveNew(report),
  });
}

export default useSaveNewCabinEvent;
